module.exports = __webpack_public_path__ + "static/media/pres35.9536f2ed.png";